// Inline English translations for workflow-related namespaces.
// These are bundled synchronously so components using useTranslation(['WORKFLOWAUTOMATION'])
// never hit the HTTP backend for these namespaces.

export const workflowTranslationKeys = {
  user_not_authorized: "You are not authorized to perform this action.",
  an_error_occurred: "An error occurred. Please try again.",
  scheduler_trigger: "Scheduler Trigger",
  event_type: "Event Type",
  delete_dormant_account: "Delete Dormant Account",
  notify_user_about_password_expiry: "Notify User About Password Expiry",
  frequency: "Frequency",
  on: "On",
  every: "Every",
  on_every: "On every",
  at: "At",
  interval: "Interval",
  in_time_zone: "In time zone",
  notify_user: "Notify User",
  send_report_to_admin: "Send Report to Admin",
  action_type: "Action Type",
  delete: "Delete",
  Disable: "Disable",
  Enable: "Enable",
  number_of_days: "Number of Days",
  event: "Event",
  user_created: "User Created",
  user_updated: "User Updated",
  event_trigger_source: "Event Trigger Source",
  select_trigger: "Select Trigger",
  via: "Via",
  no_source_selected: "No source selected",
  scheduler_to_be_configured: "Scheduler to be configured",
  click_to_select_a_trigger_to_start_your_workflow: "Click to select a trigger to start your workflow",
  add_trigger: "Add Trigger",
  start: "Start",
  end: "End",
  click_to_add_a_trigger_for_your_workflow: "Click to add a trigger for your workflow",
  this_node_decides_the_flow_trigger_type_and_configuration: "This node decides the flow trigger type and configuration",
};

export const COMMON = {
  cancel: "Cancel",
  back: "Back",
  save: "Save",
  update: "Update",
  next: "Next",
  edit: "Edit",
  delete: "Delete",
  ok: "OK",
  close: "Close",
  schedular_node_info: "Scheduler node information",
  notify_password_expiry_node_info: "Notify password expiry node information",
  delete_dormant_account_node_info: "Delete dormant account node information",
};

export const WORKFLOWAUTOMATION = {
  workflow_list: {
    section_title: "Automations",
    title: "Workflows",
    add_trigger: "Add Trigger",
    example_registration_flow: "e.g. Registration Flow",
    describe_workflow: "Describe the workflow...",
    disabled: "Disabled",
    enabled: "Enabled",
    active_version: "Active Version",
    create_workflow_to_automate: "Create workflows to automate tasks",
    loading: "Loading...",
    loading_workflows: "Loading workflows...",
    no_workflows_found: "No workflows found",
    create_your_first_workflow: "Create your first workflow",
    execution_history: "Execution History",
    create_workflow: "Create Workflow",
    add_workflow: "Add Workflow",
    on: "On",
    no_trigger: "No trigger",
    status: "Status",
    active: "Active",
    none: "None",
    disable: "Disable",
    enable: "Enable",
    workflow: "Workflow",
    versions: "Versions",
    version: "Version",
    toast_success: "Success",
    version_deleted_success: "Version deleted successfully",
    workflow_deleted_success: "Workflow deleted successfully",
    workflow_activated_success: "Workflow activated successfully",
    workflow_deactivated_success: "Workflow deactivated successfully",
    workflow_enabled_success: "Workflow enabled successfully",
    workflow_not_found: "Workflow not found",
    draft: "Draft",
    published: "Published",
    source: "Source",
    no_source: "No source",
    created_at: "Created At",
    updated_at: "Updated At",
    actions: "Actions",
    activating: "Activating...",
    activate: "Activate",
    hidden: "Hidden",
    preview: "Preview",
    workflow_name: "Workflow Name",
    description_modal: "Description",
    start_workflow: "Start Workflow",
    workflow_completed: "Workflow Completed",
    delete_workflow: "Delete Workflow",
    pam_ticket_workflow_exists: "A PAM Ticket workflow already exists",
    trigger_event_label: "Trigger Event",
  },
  validation_errors: {
    workflowName: {
      required: "Workflow name is required",
      specialCharacters: "Workflow name cannot contain special characters",
    },
    field_validation: {
      req: "This field is required",
      required: "This field is required",
      email_invalid: "Please enter a valid email address",
      phone_invalid: "Please enter a valid phone number",
      password_min_length: "Password must be at least 8 characters",
      password_complexity: "Password must contain uppercase, lowercase, number and special character",
      name_invalid: "Name can only contain letters, spaces, hyphens and apostrophes",
      name_min_length: "Name must be at least 2 characters",
      username_invalid: "Username can only contain letters, numbers and underscores",
      username_min_length: "Username must be at least 3 characters",
    },
  },
  trigger_sidebar: {
    loading_triggers: "Loading triggers...",
    trigger_configuration: "Trigger Configuration",
    schedular_configuration: "Scheduler Configuration",
    select_trigger_type: "Select trigger type",
    trigger_description: "Trigger description",
    select_sources: "Select sources",
    default_trigger: "Default trigger",
    event_based_description: "Event-based trigger description",
    scheduler_based_description: "Scheduler-based trigger description",
    no_source_selected: "No source selected",
    scheduler_to_be_configured: "Scheduler to be configured",
    click_to_select_trigger: "Click to select a trigger to start your workflow",
    scheduler_trigger: "Scheduler Trigger",
    select_trigger: "Select Trigger",
    via: "Via",
    new_user_registration: "New User Registration",
    pam_ticket_created: "PAM Ticket Created",
    user_self_registration: "User Self-Registration",
    create_user_via_admin_portal: "Create User via Admin Portal",
    scheduler_source: "Scheduler",
    signup_flow: "Signup Flow",
  },
  delete_dormant_account: {
    max_email_limit_reached: "Maximum email limit reached",
    admin_report_emails: "Admin report emails",
    select_task: "Select task",
    action: "Action",
    number_of_days: "Number of days",
    notify_user: "Notify user",
  },
  condition_sidebar: {
    filter: "Filter",
    add_step: "Add Step",
    back: "Back",
    select_step: "Select step",
    add: "Add",
    enter_value: "Enter value",
    select_an_option: "Select an option",
    enter_email_address: "Enter email address",
    enter_phone_number: "Enter phone number",
    enter_first_name: "Enter first name",
    enter_last_name: "Enter last name",
    enter_username: "Enter username",
  },
  action_sidebar: {
    task: "Task",
    add_step: "Add Step",
    back: "Back",
    back_to_step_selection: "Back to Step Selection",
    select_step: "Select Step",
    choose_a_step: "Choose a step to add to your workflow",
    select_task: "Select Task",
    select_task_description: "Choose the type of task to perform",
    assign_users_to_groups_or_roles_with_optional_conditions: "Assign users to groups or roles with optional conditions",
    search: "Search",
    fallback: "Fallback",
    conditional: "Conditional",
    assign: "Assign",
    group: "Group",
    role: "Role",
    always: "Always",
    always_alert: "This block will always execute when no conditions match.",
    fallback_alert: "This block executes when no other conditions match.",
    create_new_policy: "Create new policy",
    edit_policy: "Edit Policy",
    conditional_approval_title: "Conditional Approval",
    conditional_approval_description: "Apply an approval policy based on conditions",
    select_policy: "Select Policy",
    select_an_option: "Select an option",
    when: "When",
    add_condition_for_task: "Add condition for task",
    add_condition_button: "Add Condition",
    add_rule: "Add Rule",
    add_fallback: "Add Fallback",
    delete_last_condition_title: "Delete last condition?",
    delete_last_condition_message: "Removing the last condition will convert this block to an 'Always' block.",
    delete_conditional_block_title: "Delete this rule block?",
    delete_conditional_block_message: "Are you sure you want to delete this conditional rule block?",
  },
  condition_node_label: {
    filter: "Filter",
  },
  workflow_automation: {
    back_to_workflows: "Back to Workflows",
    loading: "Loading...",
    create: "Create",
    loading_workflow: "Loading workflow...",
    delete_node: "Delete Node",
    delete_node_confirmation: "Are you sure you want to delete this node?",
    draft_exists: "Draft Exists",
    draft_exists_message: "A draft version of this workflow exists. Do you want to continue editing it?",
    continue_editing: "Continue Editing",
    confirm_navigation: "Confirm Navigation",
    unsaved_changes_message: "You have unsaved changes. Are you sure you want to leave?",
    delete_version: "Delete Version",
    delete_workflow: "Delete Workflow",
    delete_version_confirmation: "Are you sure you want to delete this version?",
    last_version_warning: "This is the last version of the workflow.",
    delete_workflow_confirmation: "Are you sure you want to delete this workflow?",
    delete_workflow_warning: "This action cannot be undone.",
    version_limit_reached: "Version Limit Reached",
    version_limit_message: "You have reached the maximum number of versions for this workflow.",
    version_limit_suggestion: "Consider deleting older versions to create new ones.",
    event_type_is_required: "Event type is required",
    at_least_one_source_must_be_selected: "At least one source must be selected",
    please_check_and_fill_all: "Please check and fill all required fields",
    please_select_trigger: "Please select a trigger",
    please_configure_filter_or_task: "Please configure filter or task",
    please_configure_at_least_one_task_before_saving_the_workflow: "Please configure at least one task before saving the workflow",
    filterinfo: "Filter details",
    fallback: "Fallback",
    always: "Always",
    perform_assign_group_task: "Perform assign group task",
    perform_assign_role_task: "Perform assign role task",
    trigger_sidebar_title: "Trigger",
    status: "Status",
    version: "Version",
    attr_username: "Username",
    attr_email: "Email",
    attr_user_status: "User Status",
    attr_enabled: "Enabled",
    attr_disabled: "Disabled",
  },
  action_node_label: {
    more_rules: "More rules",
  },
  execution_history: {
    back_to_workflows: "Back to Workflows",
    execution_history: "Execution History",
    description: "View the execution history of your workflows",
    search_placeholder_name: "Search by workflow name",
    all: "All",
    success: "Success",
    running: "Running",
    failed: "Failed",
    workflow_name: "Workflow Name",
    version: "Version",
    category: "Category",
    triggered_type: "Triggered Type",
    status: "Status",
    started_at: "Started At",
    execution_details: "Execution Details",
    view_details: "View Details",
    loading: "Loading Execution History",
    fetching_execution_history_from_server: "Fetching execution history from server...",
    no_matching_executions_found: "No matching executions found",
    no_execution_history_found: "No execution history found",
    try_adjusting_your_search_criteria_or_filters: "Try adjusting your search criteria or filters",
    no_executions_have_been_recorded_yet: "No executions have been recorded yet",
    clear_filters: "Clear Filters",
    unknown_workflow: "Unknown Workflow",
    not_available: "N/A",
    unknown: "Unknown",
    failed_to_fetch_execution_history: "Failed to fetch execution history",
    process_instance_id_not_available: "Process instance ID not available",
    failed_to_fetch_execution_details: "Failed to fetch execution details",
    no_execution_details_available: "No execution details available",
    failed_to_fetch_workflow_data: "Failed to fetch workflow data",
    download_csv: "Download CSV",
    export_csv: "Export CSV",
    execution_success_message: "Workflow executed successfully. All actions completed without errors.",
    execution_failed_message: "Workflow execution failed. Please check the configuration and try again.",
    execution_partial_success_message: "Workflow completed with some warnings. Some actions may have been skipped.",
    execution_in_progress_message: "Workflow is currently executing. Please wait...",
    execution_unknown_message: "Workflow status is unknown.",
  },
};

export const SCHEDULER = {
  scheduler_config: {
    timezone: {
      title: "Timezone",
      desc: "Select the timezone for scheduling",
    },
    frequency: {
      title: "Frequency",
      desc: "How often to run",
    },
    startDateTime: {
      title: "Start Date and Time",
      desc: "When to start",
    },
    interval: {
      title: "Interval",
      desc: "Interval between runs",
    },
    dateTime: {
      title: "Date and Time",
      desc: "Specific date and time",
    },
  },
};
